import { Injectable } from '@angular/core';
import {SclMapConstantService} from './scl-map-constant.service';
import { cloneDeep } from 'lodash';
const sclMapConstant = SclMapConstantService;

@Injectable({
  providedIn: 'root'
})
export class SclMapGeoHereService {

  constructor() { }

  autocompleteUrl = 'https://geocoder.api.here.com/6.2/geocode.json';
  geocodeUrl = 'https://reverse.geocoder.api.here.com/6.2/reversegeocode.json';
  autocompleteBox;
  appId = 'UFP3Mq8ODsPalgiBwWVS';
  appCode = '8bZacaYx2CxDy1PUV3sN2w'; // appcode
  waitTime = 5000; // miliseconds
  radius = 50;
  initObj;
  preText = '';
  autocompleteStreet;
  state; country;
  hasPrimaryAssetAddressLookup = false; primaryAssetAddressLookupRadius; // 15393

  setSuburb(address) {
    const gotDistrict = address.Label.indexOf(address.District);
    const gotCity = address.Label.indexOf(address.City);

    if (gotDistrict >= 0 && gotCity >= 0) {
      if (gotDistrict < gotCity) {
        return address.City;
      } else {
        return address.District;
      }
    } else if (gotDistrict < 0) {
      return address.City;
    } else {
      return address.District;
    }
  }

  setupReverse(geo){
    if (geo.radius) {
      this.radius = geo.radius;
    }
    if (geo.primaryAssetAddressLookupRadius) { this.primaryAssetAddressLookupRadius = geo.primaryAssetAddressLookupRadius; }
  }

  reverse( coor, cb, cbErr, cbTimeout) {
      const lat = coor[1]; const lon = coor[0]; let radius = coor[2];
      if (this.hasPrimaryAssetAddressLookup === true) { radius = this.primaryAssetAddressLookupRadius; }
      else { radius = this.radius; }
      let link = this.geocodeUrl + '?app_id=' + this.appId + '&app_code=' + this.appCode
        + '&prox=' + lat + ',' + lon + ',' + radius + '&mode=retrieveAddresses&maxresults=1&gen=9';
      link = this.getLinkOptions( link);
      //// logger.info("HERE reverse , link = " + link);
      this.initObj.httpService.getAPI(link, {timeout: this.waitTime})
        .subscribe(data => {
            if (data && data.Response && data.Response.View && data.Response.View.length > 0
              && data.Response.View[0].Result && data.Response.View[0].Result.length > 0) {
              const suggestions = data.Response.View[0].Result[0];

              const address = suggestions.Location.Address;
              const streetData: any = cloneDeep(sclMapConstant.STREET);
              streetData.properties.streetNo = address.HouseNumber;
              streetData.properties.street = address.Street;
              streetData.properties.suburb = this.setSuburb(address);
              streetData.properties.postcode = address.PostalCode;
              streetData.properties.country = address.Country;
              streetData.properties.state = address.State;
              streetData.geometry.coordinates[0] = lon; // lon
              streetData.geometry.coordinates[1] = lat; // lat
              if (cb && typeof cb === 'function') {
                cb(streetData, { lat: suggestions.Location.DisplayPosition.Latitude,
                  lng: suggestions.Location.DisplayPosition.Longitude });
              }
            } else {
              if (cbErr && typeof cbErr === 'function') {
                cbErr('here.com reverse address lookup Error');
              }
            }
          },
          err => {
            if (err.status === -1) {
              if (cbTimeout && typeof cbTimeout === 'function') {
                cbTimeout();
              }
            } else {
              // logger.info(err);
              if (cbErr && typeof cbErr === 'function') {
                cbErr('here.com reverse address lookup Error');
              }
            }
          });
    }

  lookUp(params, cb, cbErr, cbSelectOption, cbRemoveStreet, cbTimeout ) {

      if (params == null || params.length < 1) {
        if (cbErr && typeof cbErr === 'function') {
          cbErr('params is invalid, [0] : autocompleteBox');
        }
        return;
      }
      if (this.autocompleteBox == null) {
        this.autocompleteBox = params[0];
      }


      if (params.length > 1) {
        this.search(params[1], cb, cbErr, cbTimeout);
      }

    }

  removeLookUp() {
      const id = this.initObj.keyName + 'MapGeoHere';
      const elem = document.getElementById(id);
      if (elem) {
        elem.remove();
      }

      this.autocompleteBox = null;
    }

  removeStreet(cb) {
      if (this.autocompleteStreet == null) {
        this.autocompleteStreet = document.getElementById(this.initObj.keyName + 'autocomplete');
      }
      if (this.autocompleteStreet == null) {
        if (cb && typeof cb === 'function') {
          cb();
        }
        return;
      }
      this.autocompleteStreet.value = '';

      if (cb && typeof cb === 'function') {
        cb();
      }
    }

  search(sPartialAddress, cb, cbErr, cbTimeout) {
    if ( !this.appId) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('here.com address lookup: appId is null');
      }
      return;
    }
    if ( !this.appCode) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('here.com address lookup: appCode is null');
      }
      return;
    }
    if ( sPartialAddress == null ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('here.com address lookup: text is null');
      }
      return;
    }

    const results = [];

    const newText = sPartialAddress.trim();
    if (newText === this.preText) {
      if (cb && typeof cb === 'function') {
        cb([]);
      }
      return;
    }

    this.preText = newText;

    if ( newText.length < 3 ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('here.com address lookup: text is less than 3 characters');
      }
      return;
    }

    let link = this.autocompleteUrl + '?app_id=' + this.appId + '&app_code=' + this.appCode + '&searchtext=' + sPartialAddress;
    link = this.getLinkOptions( link);
    this.initObj.httpService.getAPI(link, {timeout: this.waitTime})
      .subscribe(data => {
          if (data && data.Response && data.Response.View && data.Response.View.length > 0) {
            const suggestions = data.Response.View[0].Result;

            for (let i = 0; i < suggestions.length; i++) {
              const predict = suggestions[i];
              const sugg: any = {};
              sugg.street = predict.Location.Address.Label;
              sugg.address = predict.Location.Address;
              sugg.coordinates = predict.Location.DisplayPosition;
              results.push(sugg);
            }
            //// logger.info('result = ' + JSON.stringify(results));

            if (cb && typeof cb === 'function') {
              cb(results);
            }
          } else {
            if (cbErr && typeof cbErr === 'function') {
              cbErr('here.com address lookup Error ');
            }
          }
        },
        err => {
          if (err.status === -1) {
            if (cbTimeout && typeof cbTimeout === 'function') {
              cbTimeout();
            }
          } else {
            // logger.info(err);
            if (cbErr && typeof cbErr === 'function') {
              cbErr('here.com address lookup Error ');
            }
          }

        });
  }

  selectionOption(tpl, model, cb) {
    const address = tpl.address; const coordinates = tpl.coordinates;
    const obj: any = cloneDeep(sclMapConstant.STREET);

    obj.properties.streetNo = address.HouseNumber;
    obj.properties.street = address.Street;
    obj.properties.suburb = this.setSuburb(address);
    obj.properties.postcode = address.PostalCode;
    obj.properties.country = address.Country;
    obj.properties.state = address.State;

    const lat = parseFloat(coordinates.Latitude);
    const lon = parseFloat(coordinates.Longitude);
    obj.geometry.coordinates[0] = lon;
    obj.geometry.coordinates[1] = lat;


    if (cb && typeof cb === 'function') {
      cb(obj);
    }
  }

  getLinkOptions( link) {
      if (this.state) { link += ' ' + this.state; }
      if (this.country) { link += ' ' + this.country; }

      return link;
    }

}
